import { useTranslation } from 'react-i18next';
import { useForm } from 'antd/lib/form/Form';

import { Button, ButtonsWrapper, Form, Separator } from '@thinknet-gmbh/platform-common-ui';

import { JobInfoFormItems } from './components/job-info-form-items';
import { JobFormWrapper } from './job-form.styles';
import { DocumentFormList } from './components/document-form-list';
import { JobDescriptionsFormList } from './components/job-descriptions-form-list';
import { IJobFormProps } from './job-form.interfaces';

const JobForm = ({ onCancel, onFinish, initialValues }: IJobFormProps) => {
  const { t } = useTranslation('common');

  const [form] = useForm();

  return (
    <JobFormWrapper>
      <Form layout="vertical" onFinish={onFinish} initialValues={initialValues} form={form}>
        <JobInfoFormItems initialValues={initialValues} form={form} />
        <Separator />
        <DocumentFormList
          documents={initialValues?.documents}
          isEdit={!!initialValues}
          form={form}
        />
        <Separator />
        <JobDescriptionsFormList isEdit={!!initialValues} />
        <Separator />
        <ButtonsWrapper marginTop={16}>
          <Button type="primary" htmlType="submit">
            {t('buttons.save')}
          </Button>
          <Button onClick={onCancel}>{t('buttons.cancel')}</Button>
        </ButtonsWrapper>
      </Form>
    </JobFormWrapper>
  );
};

export default JobForm;
